import WebSocketMessage, {
  WebSocketCurrentlyViewingData,
} from "../../model/WebSocketMessage";
import eventEmitter from "../event";

/**
 * Handles a tiny notification message that is received from the server
 * The tiny notification requires the React frontend
 * Calls the react event handler with the message
 */
export const handleCurrentlyViewing = async (message: WebSocketMessage) => {
  let data: WebSocketCurrentlyViewingData;

  try {
    data = message.data as WebSocketCurrentlyViewingData;
  } catch (error) {
    return;
  }

  eventEmitter.emit("websocket:currentlyViewing", data);
};
